module.exports = {
  CORE_BASE_URL: 'https://dsp.data4game.com/dcs-api',
  AUTH_BASE_URL: 'https://dsp.data4game.com/dcs-auth',
  STORAGE_BASE_URL: 'https://dsp.data4game.com/dcs-storage',
  google: {
    client_id: "794348079659-9eod3gbdlao1hvq0ptvpo551r7hqp3ig.apps.googleusercontent.com"
  }
};
